import React from 'react'

/** Small muted heading that opens a panel section (Transformation, Appearance, Path Operations). */
export function SectionHeader({ children }: { children: React.ReactNode }) {
  return (
    <div className="h-8 flex items-center px-2">
      <h4 className="text-xs font-medium text-muted-foreground leading-normal">{children}</h4>
    </div>
  )
}
